import { useAppSelector } from './useAppSelector';
import { DriverLocation } from '@/data/models/driver-location.model';
import * as driverSlice from '@/data/slices/driver.slice';
import { useMemo } from 'react';

export const useDriverLocation = ({
  driverID,
  tripLegID,
}: {
  driverID?: number | null;
  tripLegID?: number | null;
}): DriverLocation | null => {
  const driverLocationsByDriver = useAppSelector(
    driverSlice.selectDriverLocationsById,
  );
  const driverLocationsByTripLeg = useAppSelector(
    driverSlice.selectDriverLocationsByTripLegId,
  );

  return useMemo(() => {
    if (!driverID && !tripLegID) return null;

    if (!!tripLegID && !!driverLocationsByTripLeg?.[tripLegID]) {
      return driverLocationsByTripLeg[tripLegID];
    } else if (!!driverID && !!driverLocationsByDriver?.[driverID]) {
      return driverLocationsByDriver[driverID];
    }

    return null;
  }, [driverID, tripLegID, driverLocationsByDriver, driverLocationsByTripLeg]);
};
